import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=1e3bc506&scoped=true&"
import script from "./CourseItem.vue?vue&type=script&lang=js&"
export * from "./CourseItem.vue?vue&type=script&lang=js&"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=1e3bc506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3bc506",
  null
  
)

export default component.exports